import { Haptics, ImpactOptions } from '@capacitor/haptics';
import { isPlatform } from '@ionic/react';

export const isomorficHapticsImpact = async (options: ImpactOptions) => {
  if (isPlatform('hybrid')) {
    await Haptics.impact(options);
  }
};
